import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UnifiedModule } from '../unified/unified.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgbModule,
    UnifiedModule
  ],
  exports: []
})
export class NewSettingsModule { }
